import {NewsSource, newsSourceName} from "../../types/NewsVendors";

export const NewsSourceNamePipe = "tfNewsSourceName";

export function newsSourceNamePipe() {
    return (source: NewsSource | null) => {
        if (source == null) {
            return null;
        } else {
            return newsSourceName(source);
        }
    };
}
